
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/PropertyResearchSubLandingPage",
      function () {
        return require("private-next-pages/landingPages/PropertyResearchSubLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/PropertyResearchSubLandingPage"])
      });
    }
  